module.exports = __webpack_public_path__ + "static/media/ma.0f118e3e.png";